import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar } from "lucide-react";
import Seo from "../components/Seo";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { BLOG } from "../lib/data";

const fmt = (d) => new Date(d).toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric" });

export default function Blog() {
  const [featured, ...rest] = BLOG;
  return (
    <>
      <Seo title="Blog" description="Physiotherapy tips, injury prevention and recovery advice from the team at Arena Movement Physiotherapy, Melbourne." path="/blog" />
      <PageHeader
        eyebrow="Blog & Insights"
        title="Tips to help you move better"
        subtitle="Evidence-based advice on injury prevention, recovery and getting the most from your body."
      />

      <section className="py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
          {/* FEATURED */}
          <Reveal>
            <Link to={`/blog/${featured.slug}`} className="group grid lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-16" data-testid="blog-featured">
              <div className="overflow-hidden rounded-[2rem] order-1">
                <img src={featured.image} alt={featured.title} className="w-full h-[340px] object-cover img-zoom" />
              </div>
              <div>
                <span className="inline-block rounded-full bg-navy/5 text-navy px-3 py-1 text-xs font-semibold">{featured.category}</span>
                <h2 className="mt-4 font-display text-3xl sm:text-4xl font-bold text-text-dark tracking-tight leading-snug group-hover:text-navy transition-colors">{featured.title}</h2>
                <p className="mt-4 text-lg text-text-muted leading-relaxed">{featured.excerpt}</p>
                <div className="mt-5 flex items-center gap-4 text-sm text-text-muted">
                  <span className="flex items-center gap-1.5"><Calendar className="h-4 w-4" />{fmt(featured.date)}</span>
                  <span>·</span><span>{featured.readTime}</span>
                </div>
                <span className="mt-5 inline-flex items-center gap-2 font-semibold text-navy">Read article <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" /></span>
              </div>
            </Link>
          </Reveal>

          <div className="grid md:grid-cols-2 gap-8">
            {rest.map((p, i) => (
              <Reveal key={p.slug} delay={i * 0.08}>
                <Link to={`/blog/${p.slug}`} className="group block bg-white rounded-3xl border border-border-light overflow-hidden card-hover" data-testid={`blog-card-${p.slug}`}>
                  <div className="h-52 overflow-hidden">
                    <img src={p.image} alt={p.title} className="w-full h-full object-cover img-zoom" />
                  </div>
                  <div className="p-7">
                    <span className="inline-block rounded-full bg-navy/5 text-navy px-3 py-1 text-xs font-semibold">{p.category}</span>
                    <h3 className="mt-3 font-display text-xl font-semibold text-text-dark group-hover:text-navy transition-colors leading-snug">{p.title}</h3>
                    <p className="mt-2 text-text-muted leading-relaxed">{p.excerpt}</p>
                    <div className="mt-4 flex items-center gap-3 text-sm text-text-muted">
                      <span>{fmt(p.date)}</span><span>·</span><span>{p.readTime}</span>
                    </div>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
